import { ActionPayloadGeneric, CHUuid } from "@app/root-store/actions";
import { createActionSet, createNoPropsAction } from "@app/root-store/actions/action-creators";
import { ConditionType } from "@app/rule/model/conditions";

const actionCategory = "Rule Condition";

export type ActionPayload = CHUuid & ActionPayloadGeneric;
export type BulkActionResult = CHUuid & {
    conditions: Record<string, ConditionType>;
};

export const loadSet = createActionSet<ActionPayload, BulkActionResult>(actionCategory, "load");
export const clearConditionState = createNoPropsAction(actionCategory, "clear");
